import React from "react";
import Header from "../../../../components/Header";
import Styles from "./index.module.scss";
import { useParams } from "react-router-dom";
import useRequest from "../../../../utils/useRequest";
import { getTeacherEvaluation } from "../../Service";
import EvaluateMain from "./components/EvaluateMain";
import EvaluateHeader from "./components/EvaluateMain/components/EvaluateHeader";

const Index = () => {
    const { evaluationId, multiEvaluationFlag } = useParams<{
        evaluationId: string;
        multiEvaluationFlag: string;
    }>();
    const [data, { loading }, reloadData] = useRequest(
        () => {
            // if (multiEvaluationFlag === "0") {
            return getTeacherEvaluation({ evaluationId });
            // } else {
            // return getStudentEvaluationMany({ evaluationId });
            // }
        },
        {},
        []
    );

    return (
        <div>
            <Header />
            <div className={Styles.root}>
                {data && (
                    <EvaluateMain
                        data={data}
                        reloadData={reloadData}
                        headerDom={<EvaluateHeader data={data} />}
                    />
                )}
            </div>
        </div>
    );
};

export default Index;
